import { useParams } from 'react-router-dom';
import { useResolveScreen } from '../hooks';
import { Error, Loader } from '..';
import Screen from './Screen';

const DynamicSingleViewPage = () => {
  const { id } = useParams();

  const { screen, isLoadingScreen, errorFetchingScreen } = useResolveScreen(
    id as string
  );

  if (isLoadingScreen) return <Loader />;

  if (errorFetchingScreen || !screen)
    return (
      <Error error={errorFetchingScreen?.message || 'Error resolving screen'} />
    );

  return <Screen screen={screen} id={screen.id} modelInstanceId={id} />;
};

export default DynamicSingleViewPage;
